import React from 'react';

import { StyledAvatar } from 'components/avatars';
import styled, { css } from 'styled-components';
import { CenterItemFlexContainer, StyledPaper, StyledTypography } from 'styles/common';

import { getColorFromKey } from 'constants/helper';
import { HappyEmojiIcon, SmartEmojiIcon, VeryHappyEmojiIcon, SadEmojiIcon, AngryEmojiIcon } from 'constants/icons';
import { isMobileView } from 'constants/isMobileView';
import theme from 'constants/theme';

const INPUT_TYPES = {
  EMOJI: 'EMOJI',
  DROPDOWN: 'DROP_DOWN',
  NUMBER_RATING: 'NUMBER_RATING',
};

const EMOJI_ICONS = (score, props) => {
  switch (score) {
    case 5:
      return <VeryHappyEmojiIcon size="big" {...props} leftGutter={1} rightGutter={1} />;
    case 4:
      return <HappyEmojiIcon size="big" {...props} leftGutter={1} rightGutter={1} />;
    case 3:
      return <SmartEmojiIcon size="big" {...props} leftGutter={1} rightGutter={1} />;
    case 2:
      return <SadEmojiIcon size="big" {...props} leftGutter={1} rightGutter={1} />;
    case 1:
      return <AngryEmojiIcon size="big" {...props} leftGutter={1} rightGutter={1} />;
    default:
      return null;
  }
};

const Container = styled(CenterItemFlexContainer)`
  align-items: stretch;
  flex-wrap: wrap;
  gap: 8px;
  ${'' /* height: 200px; */}
`;

const OptionContainer = styled(StyledPaper)`
  ${'' /* flex-basis: 100px; */}
  display: flex;
  justify-content: center;
  flex-direction: column;
  flex: 1 1 0;
  min-width: ${isMobileView() ? '40%' : '60px'};
  text-align: center;
  ${'' /* align-self: flex-start; */}
  ${(props) =>
    props.bgColor &&
    css`
      background: ${getColorFromKey(props.bgColor)};
    `}
  min-height: 80px;
  max-width: 200px;
`;

const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0 0 auto;
`;

const DescriptionWrapper = styled.div`
  flex-grow: 1;
  padding: 0 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

/**
 * @deprecated 21-02-2025
 */
const InteractiveInput = ({
  data,
  // for dummy components
  onSelect = () => {},
  type = INPUT_TYPES.DROPDOWN,
  selectedId = null,
  descriptionKey = 'description',
  size = 'medium',
}) => {
  const handleClick = (item) => {
    item?.id === selectedId ? onSelect(null) : onSelect(item.id);
  };

  return (
    <Container topGutter={2} bottomGutter={2}>
      {data.map((item) => (
        <OptionContainer
          key={item.id}
          clickable
          flexcontainer
          flexdirection="column"
          justifycontent="center"
          alignitems="center"
          elevation={0}
          onClick={() => handleClick(item)}
          variant={type === INPUT_TYPES.DROPDOWN ? 'outlined' : 'elevation'}
          bgColor={type === INPUT_TYPES.DROPDOWN && selectedId === item.id ? 'blue' : null}
          isTextType={type === INPUT_TYPES.DROPDOWN}
        >
          <IconContainer>
            {type === INPUT_TYPES.EMOJI &&
              EMOJI_ICONS(item.score, { color: selectedId === item.id ? 'primary' : 'grey' })}
            {type === INPUT_TYPES.NUMBER_RATING && (
              <StyledAvatar
                background={selectedId === item.id ? 'primary' : 'transparent'}
                color={selectedId === item.id ? 'white' : 'black'}
                border={`3px solid ${selectedId === item.id ? 'primary' : theme.palette.icons.borderColor}`}
                leftGutter={1}
                rightGutter={1}
                size={size}
              >
                <StyledTypography variant="h6" color={selectedId === item.id ? 'white' : theme.palette.grey.main}>
                  {item.score}
                </StyledTypography>
              </StyledAvatar>
            )}
          </IconContainer>

          <DescriptionWrapper>
            <StyledTypography
              topGutter={type === INPUT_TYPES.DROPDOWN ? 0 : 2}
              variant="body2"
              color={
                selectedId === item.id
                  ? type === INPUT_TYPES.DROPDOWN
                    ? 'white'
                    : 'primary'
                  : theme.palette.text.heading
              }
            >
              {item[descriptionKey]}
            </StyledTypography>
          </DescriptionWrapper>
        </OptionContainer>
      ))}
    </Container>
  );
};

export default InteractiveInput;
